export default "__VITE_ASSET__CfH5$hsF__"